// extracted by mini-css-extract-plugin
export var container = "_88-0";
export var icon = "_88-1";
export var text = "_88-2";